interface Props {
  url: string,
  title: string,
  className?: string
}

export default function YoutubeEmbed({ url, title, className = '' }: Props) {
  return (
    <iframe className={`rounded-2xl ${className}`} src={`https://www.youtube-nocookie.com/embed/${url}`} title={title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerPolicy="strict-origin-when-cross-origin" allowFullScreen>
    </iframe>
  );
}
